/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const AuthRoles = {
    AggregatedDataReader: 'AggregatedDataReader',
    MeteringPointReader: 'MeteringPointReader',
    MeteringPointWriter: 'MeteringPointWriter',
    VEEReader: 'VEEReader',
    VEEWriter: 'VEEWriter',
    ChargeInformationReader: 'ChargeInformationReader',
    ChargeInformationWriter: 'ChargeInformationWriter',
    ConnectionPointWriter: 'ConnectionPointWriter',
    ConnectionPointReader: 'ConnectionPointReader',
    Hangfire: 'Hangfire',
    TopologyReader: 'TopologyReader',
    TopologyWriter: 'TopologyWriter',
} as const;
export type AuthRoles = typeof AuthRoles[keyof typeof AuthRoles];

